import union from 'lodash/union';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function didNotReduce(prev: any, next: any): boolean {
    const keys = union(Object.keys(prev), Object.keys(next));
    for (const key of keys) {
        if (prev[key] !== next[key]) {
            return false;
        }
    }
    return true;
}
